// extracted by mini-css-extract-plugin
export var boldText = "_7y-4";
export var checkboxContainer = "_7y-6";
export var closeIcon = "_7y-i";
export var container = "_7y-0";
export var drawer = "_7y-8";
export var drawerContent = "_7y-9";
export var extraSmallText = "_7y-5";
export var fulfillmentGroupTable = "_7y-e";
export var largeText = "_7y-3";
export var loadingSpinnerContainer = "_7y-j";
export var mediumText = "_7y-2";
export var narrow = "_7y-f";
export var notificationLink = "_7y-l";
export var packageCheckIconContainer = "_7y-7";
export var slideoutHeaderActions = "_7y-g";
export var slideoutHeaderActionsShifted = "_7y-h";
export var slideoutHeaderContainer = "_7y-a";
export var slideoutModal = "_7y-c";
export var stickyHeaderWrapper = "_7y-b";
export var table = "_7y-k";
export var tableContainer = "_7y-d";
export var tertiaryText = "_7y-1";